"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rx = void 0;
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var Rx = /** @class */ (function () {
    function Rx() {
    }
    Rx.mapQ = function (observable, mapper) {
        return observable.pipe(operators_1.map(function (e) { return JSON.parse(e); }), operators_1.flatMap(function (e) {
            if (e.errors && e.errors.length > 0)
                return rxjs_1.throwError(Error(e.errors[0].message));
            return rxjs_1.of(mapper(e.data));
        }));
    };
    Rx.flatMapQ = function (observable, mapper) {
        return observable.pipe(operators_1.map(function (e) { return JSON.parse(e); }), operators_1.flatMap(function (e) {
            if (e.errors && e.errors.length > 0)
                return rxjs_1.throwError(Error(e.errors[0].message));
            return rxjs_1.defer(function () { return mapper(e.data); });
        }));
    };
    Rx.mapM = function (observable, mapper) {
        return observable.pipe(operators_1.map(function (e) { return JSON.parse(e); }), operators_1.flatMap(function (e) {
            if (e.errors && e.errors.length > 0)
                return rxjs_1.throwError(Error(e.errors[0].message));
            return rxjs_1.of(mapper(e.data));
        }));
    };
    Rx.flatMapM = function (observable, mapper) {
        return observable.pipe(operators_1.map(function (e) { return JSON.parse(e); }), operators_1.flatMap(function (e) {
            if (e.errors && e.errors.length > 0)
                return rxjs_1.throwError(Error(e.errors[0].message));
            return rxjs_1.defer(function () { return mapper(e.data); });
        }));
    };
    return Rx;
}());
exports.Rx = Rx;
//# sourceMappingURL=rx.js.map